<section class="dashboard container-fluid">
  <h1 class="h2 mb-2">Panel de Control</h1>
  <p class="text-body-secondary mb-4">Resumen de recursos por módulo.</p>
  <div class="row g-3">
    @for (module of modules(); track module.id_universal) {
    <div class="col-12 col-sm-6 col-xl-3">
      <a class="card dashboard-card h-100 text-decoration-none" [routerLink]="['/working/module', module.id_universal]">
        <div class="card-body d-flex align-items-center gap-3">
          <span class="dashboard-icon"><i class="bi bi-grid-3x3-gap"></i></span>
          <span>
            <span class="d-block fw-semibold">{{ module.fd_product }}</span>
            <span class="text-body-secondary small">
              {{ module.resources.length }} recursos
            </span>
          </span>
        </div>
      </a>
    </div>
    }
  </div>
</section>
